import React from 'react';
import DataResource from '../../common/v4/DataResource'
import Panel from '../../common/layout/Panel'
import Feature from '../../admin/Feature'
import { useState, useEffect } from 'react';
import { getOne, create } from './../../common/v4/BackendProvider';
import { EditPage, EditPageTextField, EditPageCheckbox, EditPageSelect, EditPagePanel } from './../../common/EditPage';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
var imm = require('immutable');

const VoiceRates = (props) => {

    const [metadata, setMetadata] = useState({});
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({
        'ATRSTARTTIME': new Date().toISOString().split('T')[0],
    });
    const navigate = useNavigate();
    const { product_id } = useParams();

    useEffect(() => {
        setLoading(true);
        getOne(`/admin/products/products/${product_id}/voicerates/`, 'new')
            .then(response => {
                setMetadata(response.data.metadata);
                setLoading(false);
            }).catch(error => {
                setLoading(false);
                toast.error("Error fetching rate profile: " + error.message, {});
            });
    }, []);

    const handleSave = () => {
        setLoading(true);
        create(`/admin/products/products/${product_id}/voicerates/`, {data: data}).then(response => {
            toast.success("Rate profile mapping created successfully", {});
            setLoading(false);
            setData({
                'ATRSTARTTIME': new Date().toISOString().split('T')[0],
                'ATRRATEID': null,
                'ATRROUTINGGROUPID': null,
                'ATRPREFIX': null,
                'ATRCALLERIDCODEBANDID': null,
            });
        }).catch(error => {
            toast.error("Error creating rate profile mapping: " + error.message, {});
            setLoading(false);
        });
    }

    const handleCancel = () => {
        navigate('/products/rate_profiles');
    }

    const onChange = (id, value) => {
        setData({...data, [id]: value});
    }

    const resData = {
        product_id: product_id,
        url: `/admin/products/products/${product_id}/voicerates`,
        data: {
            data: [],
                metadata: []
            },
        metadata: [
            {
                label: 'id',
                source: 'id',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                label: 'Rate Table',
                source: 'name',
                type: 'text',
                editable: true,
            },
            {
                label: 'Routing Group',
                source: 'ATRROUTINGGROUPID',
                type: 'select',
                editable: true
            },
            {
                label: 'Prefix',
                source: 'prefix',
                type: 'text',
                editable: true,
                default: ''
            },
            {
                label: 'Caller ID Code Band',
                source: 'ATRCALLERIDCODEBANDID',
                type: 'select',
                editable: true,
                default: 0
            },
            {
                label: 'Activation Time',
                source: 'start_time',
                type: 'datetime',
                editable: true,
                default: 'NOW'
            },
            {
                label: 'Status',
                source: 'status',
                visible_add: false,
                visible_edit: true,
                editable: false,
                type: 'icon',
                values : {
                    FUTURE: 'FUTURE',
                    CURRENT: 'CURRENT',
                    EXPIRED: 'EXPIRED'
                },
                classnames : {
                    FUTURE: 'label label-warning',
                    CURRENT: 'label label-info',
                    EXPIRED: 'label label-danger'
                }
            },
            {
                label: 'Delete',
                type: 'delete',
                visible: true
            }
        ]
    }
        
    return (<> 
        <Panel title = "Voice Rate Mappings">
            <div>
                <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title="Create Voice Rate Mapping">
                    <EditPagePanel>
                        <EditPageSelect label="Rate Table" nullable id="ATRRATEID" onChange={ onChange } value={ data.ATRRATEID } options={ metadata?.voicerates?.values } />
                        <EditPageSelect label="Routing Group" id="ATRROUTINGGROUPID" onChange={ onChange } value={ data.ATRROUTINGGROUPID } options={ metadata?.ATRROUTINGGROUPID?.values } />
                        <EditPageTextField label="Prefix" id="ATRPREFIX" onChange={ onChange } value={ data.ATRPREFIX } />
                        <EditPageSelect label="Caller ID Code Band" id="ATRCALLERIDCODEBANDID" onChange={ onChange } value={ data.ATRCALLERIDCODEBANDID } options={ metadata?.ATRCALLERIDCODEBANDID?.values } />
                        <EditPageTextField label="Activation Time" id="ATRSTARTTIME" onChange={ onChange } value={ data.ATRSTARTTIME } />
                    </EditPagePanel>
                </EditPage>
                <DataResource
                    addButtonText = "Add Voice Rate Mapping"  
                    loading = {loading}
                    data = {resData}
                    {...props} 
                />
            </div>
        </Panel>
        </>
    )
}



const SmsRates = (props) => {
    const { product_id } = useParams();
    const [metadata, setMetadata] = useState({});
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({
        'ATRSTARTTIME': new Date().toISOString().split('T')[0],
    });
    const navigate = useNavigate();
    const resData = {
        product_id: product_id,
        url: `/admin/products/products/${product_id}/smsrates`,
        data: {
            data: [],
            metadata: []
        },
            metadata: [
                {
                    label: 'id',
                    source: 'id',
                    type: 'primary',
                    editable: false,
                    visible: false
                },
                {
                    label: 'Outbound (MT) Rate Table',
                    source: 'rate_out',
                    type: 'text',
                    editable: true,
                },
                {
                    label: 'Inbound (MO) Rate Table',
                    source: 'rate_in',
                    type: 'text',
                    editable: true,
                },
                {
                    label: 'Routing Group',
                    source: 'routing_group',
                    type: 'select',
                    editable: true,
                },
                {
                    label: 'Activation Time',
                    source: 'start_time',
                    type: 'datetime',
                    editable: true,
                    default: 'NOW'
                },
                {
                    label: 'Status',
                    source: 'status',
                    visible_add: false,
                    visible_edit: true,
                    editable: false,
                    type: 'icon',
                    values : {
                        FUTURE: 'FUTURE',
                        CURRENT: 'CURRENT',
                        EXPIRED: 'EXPIRED'
                    },
                    classnames : {
                        FUTURE: 'label label-warning',
                        CURRENT: 'label label-info',
                        EXPIRED: 'label label-danger'
                    }
                },
                {
                    label: 'Delete',
                    type: 'delete',
                    visible: true
                }
            ]
    }
    useEffect(() => {
        setLoading(true);
        getOne(`/admin/products/products/${product_id}/smsrates/`, 'new')
            .then(response => {
                setMetadata(response.data.metadata);
                setLoading(false);
            }).catch(error => {
                setLoading(false);
                toast.error("Error fetching rate profile: " + error.message, {});
            });
    }, []);

    const handleSave = () => {
        setLoading(true);
        create(`/admin/products/products/${product_id}/smsrates/`, {data: data}).then(response => {
            toast.success("SMS rate mapping created successfully", {});
            setLoading(false);
            setData({
                'ATRSTARTTIME': new Date().toISOString().split('T')[0],
                'ATRRATEID': null,
                'ATRROUTINGGROUPID': null,
                'ATRPREFIX': null,
                'ATRCALLERIDCODEBANDID': null,
            });
        }).catch(error => {
            toast.error("Error creating SMS rate mapping: " + error.message, {});
            setLoading(false);
        });
    }

    const handleCancel = () => {
        navigate('/products/rate_profiles');
    }

    const onChange = (id, value) => {
        setData({...data, [id]: value});
    }

    return (<> 
        <Panel title = "SMS Rate Mappings">
            <div>
                <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title="Create SMS Rate Mapping">
                    <EditPagePanel>
                        <EditPageSelect label="Outbound (MT) Rate Table" nullable id="ATRSMSRATEIDOUT" onChange={ onChange } value={ data.ATRSMSRATEIDOUT } options={ metadata?.smsrates?.values } />
                        <EditPageSelect label="Inbound (MO) Rate Table" nullable id="ATRSMSRATEIDIN" onChange={ onChange } value={ data.ATRSMSRATEIDIN } options={ metadata?.smsrates?.values } />
                        <EditPageSelect label="Routing Group" id="ATRSMSROUTINGGROUPID" onChange={ onChange } value={ data.ATRSMSROUTINGGROUPID } options={ metadata?.ATRROUTINGGROUPID?.values } />
                        <EditPageTextField label="Activation Time" id="ATRSTARTTIME" onChange={ onChange } value={ data.ATRSTARTTIME } />
                    </EditPagePanel>
                </EditPage>
                <DataResource
                    addButtonText = "Add SMS Rate Mapping"  
                    loading = {loading}
                    data = {resData}
                    {...props} 
                />
            </div>
        </Panel>
        </>
    )
}



const MmsRates = (props) => {
    const { product_id } = useParams();
    const data = {
        product_id: product_id,
        url: `/admin/products/${product_id}/mmsrates`,
        data: {
                data: [],
                metadata: []
            },
            metadata: [
                {
                    label: 'id',
                    source: 'mms_rate_prod_id',
                    type: 'primary',
                    editable: false,
                    visible: false
                },
                {
                    label: 'Outbound Rate Table',
                    source: 'mms_rate_id_out',
                    type: 'select',
                    editable: true,
                },
                {
                    label: 'Inbound Rate Table',
                    source: 'mms_rate_id_in',
                    type: 'select',
                    editable: true,
                },
                {
                    label: 'Routing Group',
                    source: 'mms_routing_group_id',
                    type: 'select',
                    editable: true,
                },
                {
                    label: 'Activation Time',
                    source: 'activated_at',
                    type: 'datetime',
                    editable: true,
                    default: 'NOW'
                },
                {
                    label: 'Status',
                    source: 'STATUS',
                    visible_add: false,
                    visible_edit: true,
                    editable: false,
                    type: 'icon',
                    values : {
                        FUTURE: 'FUTURE',
                        CURRENT: 'CURRENT',
                        EXPIRED: 'EXPIRED'
                    },
                    classnames : {
                        FUTURE: 'label label-warning',
                        CURRENT: 'label label-info',
                        EXPIRED: 'label label-danger'
                    }
                },
                {
                    'label' : 'Actions',
                    'type': 'action_buttons'
                },
            ]
        }
        return (
            <Panel title = "MMS Rate Mappings">
                <DataResource
                    addButtonText = "Add MMS Rate Mapping"
                    data = {data}
                    {...props}
                />
            </Panel>
    )
}

const RecurringFees = (props) => {
    const { product_id } = useParams();
    const data = {
        product_id: product_id,
        url: `/admin/products/${product_id}/smsrecurring`,
        data: {
                data: [],
                metadata: []
            },
            metadata: [
                {
                    label: 'id',
                    source: 'ATRSMSRECURRINGFEEID',
                    type: 'primary',
                    editable: false,
                    visible: false
                },
                {
                    label: 'Cycle',
                    source: 'ATRPERIOD',
                    type: 'select',
                    editable: true,
                    default: 'monthly'
                },
                {
                    label: 'Charge Amount',
                    source: 'ATRAMOUNT',
                    type: 'text',
                    editable: true,
                    default: '0.00',
                    placeholder: '0.00'
                },
                {
                    label: 'Currency',
                    source: 'ATRCURID',
                    type: 'select',
                    editable: true,
                    default: 1
                },
                {
                    label: 'DID Charge Group',
                    source: 'ATRDIDCHARGEGROUPID',
                    type: 'select',
                    editable: true
                },
                {
                    'label' : 'Actions',
                    'type': 'action_buttons'
                },
            ]
        }
        return (
            <Panel title = "SMS DID Number Recurring Fees">
                <DataResource
                    addButtonText = "Add Recurring Fee"                    
                    data = {data}
                    {...this.props} 
                />
            </Panel>
    )
}

const ProductMapping = (props) => {
    // this will go as soon as we convert to complete react routing
    const { product_id } = useParams();
    const [data, setData] = useState({});
    
    useEffect(() => {
        getOne(`/admin/products/products/`, product_id)
            .then(response => {
                setData(response.data.data);
            })
            .catch(error => {
                console.error('Error fetching product data:', error);
            });
    }, [product_id]);
   
    return (
        <div>
            <div className="row">
                <div className="col-md-12">
                    <h2>Rate Profile: {data.ATRPRODUCTNAME}</h2>
                </div>
            </div>
            <Feature name="voice-wholesale">
                <VoiceRates
                    product_id = {product_id}
                    type={ data.ATRPRODUCTTYPE }
                />
            </Feature>
            <Feature name="sms-wholesale">
                <SmsRates 
                    product_id={product_id} 
                />                
            </Feature>
            { data.ATRPRODUCTTYPE != 3 &&
                <Feature name="mms-wholesale">
                    <MmsRates
                        product_id={product_id}
                    />
                </Feature>
            }
            { data.ATRPRODUCTTYPE != 3 &&
                <Feature name="sms-recurring-fees">
                    <RecurringFees 
                        product_id={product_id} 
                    />           
                </Feature>
            }
        </div>
    )
}

export default ProductMapping;